import { useReducer } from "react";
import { Moment } from 'moment';

export interface IDateRange {
  startDate?: Moment;
  endDate?: Moment;
  focus: "startDate" | "endDate" | null;
}

export enum DateRangeOptions {
  SET_DATES = "SET_DATES",
  SET_FOCUS = "SET FOCUS"
}

type returned = [IDateRange, React.Dispatch<any>];

const initialDateRange: IDateRange = { startDate: undefined, endDate: undefined, focus: null };

const dateRangeReducer = (state: IDateRange, action) => {
  switch (action.type) {
    case DateRangeOptions.SET_DATES:
      return { ...state, ...action.payload };
    case DateRangeOptions.SET_FOCUS:
      return { ...state, focus: action.payload };
    default:
      throw new Error("Selected action is not implemented");
  }
};

const useDateRangeFilter = (): returned => {
  const [dateRange, dispatch] = useReducer(dateRangeReducer, initialDateRange);
  return [dateRange, dispatch];
};

export default useDateRangeFilter;
